import React, { useState, useEffect } from 'react';
import { Sparkles, ChevronRight, Award, Users } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import {
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
} from 'react-icons/fa';
import imageSrc from '../assets/image.jpeg';
import hero from '../assets/iSnap.mp4';

const image = imageSrc;

const Hero = () => {
  const roles = ['Creative Producer', 'Visual storyteller', 'Creative thinker', 'Production problem-solver'];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setIndex((i) => (i + 1) % roles.length), 3000);
    return () => clearInterval(timer);
  }, [roles.length]);

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden pt-16"
    >
      {/* ─── Video Background ─── */}
      <div className="absolute inset-0 w-full h-full z-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
          poster={image}
        >
          <source
            // src="https://www.w3schools.com/html/mov_bbb.mp4"
            src={hero}
            type="video/mp4"
          />
          {/* Fallback image if video fails */}
          <img
            src={image}
            alt="Hero background"
            className="absolute inset-0 w-full h-full object-cover"
          />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80" />
        <div className="absolute inset-0 bg-gradient-to-r from-yellow-600/10 via-transparent to-yellow-600/10 pointer-events-none" />
      </div>

      {/* ─── Content ─── */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            {/* <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-yellow-500/20 border border-yellow-500/30 text-yellow-300 text-sm font-medium mb-6 backdrop-blur-sm">
              <Sparkles size={16} />
              <span>Available for freelance</span>
            </div> */}
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-7xl font-bold leading-tight text-white">
              Creative<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-500">
                Producer
              </span>
            </h1>
            <p className="text-xl text-gray-200 mt-4 max-w-lg leading-relaxed drop-shadow-md">
              I'm a <span className="text-white font-semibold">{roles[index]}</span>
              <br />
              {/* blending design and motion to create unforgettable experiences. */}
              {/* I create purposeful visual experiences across graphic design, motion design, videography, video editing, photography, and photo editing—turning ideas into visuals that communicate, connect, and leave an impression. */}
              I’m a multidisciplinary Creative Producer in Ghana specialising in graphic design, motion design, videography, video editing, photography, and photo editing.

              From the first idea to the final frame, I create purposeful visual content that helps brands, organisations, and audiences see, understand, and remember the message.
            </p>
            <div className="flex flex-wrap gap-4 mt-8">
              <Link
                to={`/portfolio`}
                onClick={() => document.getElementById('portfolio')?.scrollIntoView({ behavior: 'smooth' })}
                className="px-8 py-3.5 rounded-full bg-gradient-to-r from-yellow-500 to-yellow-600 text-white font-medium flex items-center gap-2 hover:shadow-2xl hover:shadow-yellow-500/30 transition group"
              >
                Explore My Work
                <ChevronRight size={18} className="group-hover:translate-x-1 transition" />
              </Link>
              <Link
                to={`/contact`}
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="px-8 py-3.5 rounded-full border border-white/30 text-white font-medium hover:bg-white/10 backdrop-blur-sm transition"
              >
                Let’s Create Together
              </Link>
            </div>
            {/* <div className="flex gap-4 mt-8">
              <a
                href="#"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-gray-200 hover:text-white hover:border-yellow-400/50 hover:bg-yellow-500/20 backdrop-blur-sm transition"
                aria-label="Instagram"
              >
                <FaInstagram size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-gray-200 hover:text-white hover:border-yellow-400/50 hover:bg-yellow-500/20 backdrop-blur-sm transition"
                aria-label="LinkedIn"
              >
                <FaLinkedin size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-gray-200 hover:text-white hover:border-yellow-400/50 hover:bg-yellow-500/20 backdrop-blur-sm transition"
                aria-label="Twitter"
              >
                <FaTwitter size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-gray-200 hover:text-white hover:border-yellow-400/50 hover:bg-yellow-500/20 backdrop-blur-sm transition"
                aria-label="YouTube"
              >
                <FaYoutube size={18} />
              </a>
            </div> */}
          </div>

          <div className="relative hidden lg:block">
            <div className="relative aspect-square max-w-lg mx-auto">
              <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-yellow-600/20 to-yellow-600/20 blur-3xl" />
              <div className="relative w-full h-full rounded-full overflow-hidden border-2 border-yellow-500/30 shadow-2xl shadow-yellow-500/20">
                <img
                  src={image}
                  alt="Designer portrait"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* <div className="absolute -top-4 -right-4 bg-black/80 backdrop-blur-xl border border-white/10 rounded-2xl px-5 py-3 shadow-2xl animate-float">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-amber-500/20 flex items-center justify-center">
                    <Award size={20} className="text-amber-400" />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-white">5+ Years</div>
                    <div className="text-xs text-gray-400">Experience</div>
                  </div>
                </div>
              </div>
              <div className="absolute -bottom-4 -left-4 bg-black/80 backdrop-blur-xl border border-white/10 rounded-2xl px-5 py-3 shadow-2xl animate-float-delayed">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-yellow-500/20 flex items-center justify-center">
                    <Users size={20} className="text-yellow-400" />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-white">100+</div>
                    <div className="text-xs text-gray-400">Happy Clients</div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* ─── Scroll Indicator ─── */}
      {/* <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce z-10">
        <div className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center p-1 backdrop-blur-sm">
          <div className="w-1.5 h-3 rounded-full bg-yellow-400/80" />
        </div>
      </div> */}

      {/* ─── Animations ─── */}
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        .animate-float { animation: float 6s ease-in-out infinite; }
        .animate-float-delayed { animation: float 8s ease-in-out infinite 1s; }
      `}</style>
    </section>
  );
};

export default Hero;